/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ChatEyeIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB40lEQVR4nN1UzU5TURC+GECJytKFO30A5Q0aFjU3ofNzIaczrU3Y9RWMsuiSJhISWLnXAAGfwCdwBbrRhf9RqGtjjC4IZlqBc+89ty1lJZNM0uRMv2++mW9uFF3ocM5NEkkdSDeR9SOQ/rJEkg9IsoFJVZvN5sRI4BWqLQDJV2Q9GpBfEBWHBm61WpeAZG0I4CM/gWU1iqKxgQTIsn5WcEyTFAewVkcFx39ZoRoHwUuLi1e688x2RXIArA8B9I5z7prlXFK9CySPkLSTr9f3Zo5Q97VA8bNyuXG1SLGRdd2UV7EQmv3zVCHJRnZpSdK4ASz7yNr2uhwD1q3AfzME5u3TZe3GcXw5pxLcLQ+onRov6SuP4G1Agf4+KcDqbOoN9ebcfP02krzwmthPkSdaPn3TH/kdkP4pIoDeWLKO+ebXVFju9SXIjGjPZHvq2gEDLB+/O+emkOW19/Ymr4BlJ300unW8ZFuokZiS7JLt8pF0e+CSQzbtWhDxelQQcXx/Oueg3gTmc8XWEbB+ypNox46KqD5jZJbd3yxLyPJ96EPrLVoenPdTASwUBLcj8hc9Yj4OgpsLgOXl+cBlpfBzDSxPRgYm+UxUg6hfmDQgORyy05/I+g5JnmIirlQqjfcF/+/jL37UK1sAwO+uAAAAAElFTkSuQmCC)
 */
export const ChatEyeIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M12 10a2 2 0 0 1-2.75 1.85c-.12-.04-.25.03-.25.15a3 3 0 1 0 3-3c-.12 0-.2.13-.15.25A2 2 0 0 1 12 10Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M12 22a10 10 0 1 0-8.45-4.64c.13.19.11.44-.04.61l-2.06 2.37A1 1 0 0 0 2.2 22H12Zm6.85-9.65C18.3 13.48 16.27 17 12 17s-6.3-3.52-6.85-4.65a.8.8 0 0 1 0-.7C5.7 10.52 7.73 7 12 7s6.3 3.52 6.85 4.65c.1.22.1.48 0 .7Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
